export default __webpack_public_path__ + "static/media/kid20.e806b68e.jpg";